import { receiptDeleteApi } from "../../api/receipt/receiptDeleteApi"

type PayloadShape = Parameters<typeof receiptDeleteApi>[0]

export async function receiptDeleteService(payload: PayloadShape, token: string) {
	return await receiptDeleteApi(payload, token)
}
